import * as React from "react"
import { LucideIcon } from "lucide-react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "../../lib/utils"

const iconVariants = cva("", {
  variants: {
    size: {
      sm: "h-4 w-4",
      default: "h-5 w-5", 
      lg: "h-6 w-6",
      xl: "h-8 w-8",
    },
  },
  defaultVariants: {
    size: "default",
  },
})

export interface IconProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof iconVariants> {
  icon: LucideIcon
}

const Icon = React.forwardRef<HTMLDivElement, IconProps>(
  ({ className, size, icon: IconComponent, ...props }, ref) => {
    return (
      <div ref={ref} className={cn(iconVariants({ size, className }))} {...props}>
        <IconComponent className="h-full w-full" />
      </div>
    )
  }
)
Icon.displayName = "Icon"

export { Icon, iconVariants } 